import { visitExit as visitNodeExit, Nodes, visitSkip } from "./Nodes";
export var Elements;
(function (_Elements) {
  var visitExit = _Elements.visitExit = visitNodeExit;
  function predicate(predicate) {
    if (typeof predicate === 'string') {
      var id = predicate;
      return function (node) {
        return node.identifier === id;
      };
    }
    return predicate;
  }
  _Elements.predicate = predicate;
  function route(elements, predicate) {
    if (!predicate) {
      throw new Error("predicate required");
    }
    var nodePredicate = Elements.predicate(predicate);
    // console.log(`route`, predicate,nodePredicate)

    var route = null;
    Nodes.visit(elements, {
      element: {
        enter: function enter(node) {
          if (route) {
            return Elements.visitExit;
          }
          if (nodePredicate(node)) {
            route = [node];
            return Elements.visitExit;
          }
          return;
        },
        exit: function exit(node) {
          if (route) {
            route.push(node);
          }
        }
      }
    });
    return route;
  }
  _Elements.route = route;
  function findParents(elements, predicate) {
    var nodePredicate = Elements.predicate(predicate);
    var parents = [];
    var findNode = null;
    Nodes.visit(elements, {
      element: {
        enter: function enter(node) {
          if (findNode) {
            return Elements.visitExit;
          }
          if (nodePredicate(node)) {
            findNode = node;
            return Elements.visitExit;
          }
          return;
        },
        exit: function exit(node) {
          if (findNode) {
            parents.push(node);
          }
        }
      }
    });
    return findNode ? parents : null;
  }
  _Elements.findParents = findParents;
  function findNodes(elements, predicate) {
    var nodePredicate = Elements.predicate(predicate);
    var nodes = [];
    var findNode = null;
    Nodes.visit(elements, {
      element: {
        enter: function enter(node) {
          if (findNode) {
            return Elements.visitExit;
          }
          if (nodePredicate(node)) {
            findNode = node;
            return Elements.visitExit;
          }
          return;
        },
        exit: function exit(node) {
          if (findNode) {
            nodes.push(node);
          }
        }
      }
    });
    return findNode ? nodes : null;
  }
  _Elements.findNodes = findNodes;
  function find(elements, predicate) {
    var nodePredicate = Elements.predicate(predicate);
    var findNode = null;
    Nodes.visit(elements, {
      element: {
        enter: function enter(node) {
          if (findNode) {
            return Elements.visitExit;
          }
          if (nodePredicate(node)) {
            findNode = node;
            return Elements.visitExit;
          }
          return;
        }
      }
    });
    return findNode;
  }
  _Elements.find = find;
  function findParent(elements, predicate) {
    var nodePredicate = Elements.predicate(predicate);
    var parent = visitExit;
    Nodes.visit(elements, {
      element: {
        enter: function enter(node, parentNode) {
          if (nodePredicate(node)) {
            parent = parentNode;
            return visitExit;
          }
          return;
        },
        exit: function exit() {}
      }
    });
    return parent;
  }
  _Elements.findParent = findParent;
  function pick(elements, predicate) {
    var picked = [];
    Nodes.visit(elements, {
      element: {
        enter: function enter(element) {
          if (predicate(element)) {
            picked.push(element);
            return visitSkip;
          }
          return;
        }
      }
    });
    return picked;
  }
  _Elements.pick = pick;
})(Elements || (Elements = {}));